import apiInstance from '../utils/axiosConfig';

const HabilitationService = {
    // Récupérer toutes les habilitations
    getAllHabilitations: async () => {
        try {
            const response = await apiInstance.get('/habilitations/getAllHabilitations');
            return response.data;
        } catch (error) {
            console.error('Error fetching all habilitations:', error.message || error);
            throw error;
        }
    },

    // Récupérer les habilitations par type
    getHabilitationsByType: async (type) => {
        try {
            const response = await apiInstance.get(`/habilitations/getHabilitationsByType/${type}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching habilitations by type:', error.message || error);
            throw error;
        }
    }
};

export default HabilitationService;